import DateTimePicker from '@components/v2/form/DateTimePicker/DateTimePicker';
import { Box } from '@mui/material';
import { Control, useController } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { CatalogCreationAccessDateFieldName } from '../catalogCreationAccess.types';
import { CatalogCreationAccessAddFormValues } from '../catalogCreationAccessAdd.schema';

interface CatalogCreationAccessAddDateFieldProps {
  control: Control<CatalogCreationAccessAddFormValues>;
  name: CatalogCreationAccessDateFieldName;
  label: LangEnum;
  helperText: string;
  testId: string;
}

const CatalogCreationAccessAddDateField = ({
  control,
  name,
  label,
  helperText,
  testId,
}: CatalogCreationAccessAddDateFieldProps) => {
  const { translate } = useTranslation();
  const { field, fieldState } = useController({ control, name });

  return (
    <Box test-id={testId}>
      <DateTimePicker
        label={translate(label)}
        error={!!fieldState.error}
        helperText={fieldState.error?.message ?? helperText}
        {...field}
      />
    </Box>
  );
};

export default CatalogCreationAccessAddDateField;
